module.exports = __webpack_public_path__ + "img/bidv2.1bce4256.jpg";